<template>
    <v-layout>
        <v-flex xs12 md6>
            <v-card class="mx-auto text-center" color="green" dark max-width="600">
                <v-card-text>
                    <v-sheet color="rgba(0, 0, 0, .12)">
                        <v-sparkline
                            :labels="sparkline_artists_label"
                            :value="sparkline_artists_value"
                            color="rgba(255, 255, 255, .7)"
                            height="100"
                            padding="24"
                            stroke-linecap="round"
                            smooth
                        >
                            <template v-slot:label="item">{{ item.value }}</template>
                        </v-sparkline>
                    </v-sheet>
                </v-card-text>

                <v-card-text>
                    <div class="display-1 font-weight-thin">Novos Artistas nos últimos 7 dias</div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="justify-center">
                    <!--v-btn block text>Go to Report</v-btn-->
                </v-card-actions>
            </v-card>
        </v-flex>
        <v-flex xs12 md6>
            <v-card class="mx-auto text-center" color="orange" dark max-width="600">
                <v-card-text>
                    <v-sheet color="rgba(0, 0, 0, .12)">
                        <v-sparkline
                            :labels="sparkline_products_label"
                            :value="sparkline_products_value"
                            color="rgba(255, 255, 255, .7)"
                            height="100"
                            padding="24"
                            stroke-linecap="round"
                            smooth
                        >
                            <template v-slot:label="item">{{ item.value }}</template>
                        </v-sparkline>
                    </v-sheet>
                </v-card-text>

                <v-card-text>
                    <div class="display-1 font-weight-thin">Produtos criados nos últimos 7 dias</div>
                </v-card-text>



                <v-divider></v-divider>

                <v-card-actions class="justify-center">
                    <!--v-btn block text>Go to Report</v-btn-->
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>
<script>
import PacatoYService from "../../../app/rest/pacatoY";

let pacatoYService = null;

export default {
    data() {
        return {
            bla: "blablabla",
            sparkline_artists_label: [],
            sparkline_artists_value: [],
            sparkline_products_label: [],
            sparkline_products_value: []
        };
    },
    beforeCreate: function() {
        pacatoYService = PacatoYService.build();
        pacatoYService.dashboard().then(e => {
            this.sparkline_artists_label = e.items.artists_report_registration.map(
                function(e) {
                    return e.day;
                }
            );
            this.sparkline_artists_value = e.items.artists_report_registration.map(
                function(e) {
                    return e.total;
                }
            );

            this.sparkline_products_label = e.items.products_report_registration.map(
                function(e) {
                    return e.day;
                }
            );
            this.sparkline_products_value = e.items.products_report_registration.map(
                function(e) {
                    return e.total;
                }
            );
        });
    }
};
</script>